import type { ReactNode } from 'react'

/**
 * The record lane's two columns (SA-447; the SA-340 wireframe's `.rcols`):
 * the work (flexible) beside the enquiry (300–360px, room for SA-449's
 * sector table). A container query, not a viewport breakpoint: two columns
 * once the frame is 50rem wide, which is about a 1100px viewport with the
 * sidebar open and earlier with it collapsed. Narrower, one column: the
 * work, then the enquiry.
 */
export function RecordColumns({ work, enquiry }: { work: ReactNode; enquiry: ReactNode }) {
  return (
    <div data-slot="record-columns" className="@container/record">
      <div className="grid items-start gap-6 @min-[50rem]/record:grid-cols-[minmax(0,1fr)_minmax(300px,360px)]">
        <div data-column="work" className="min-w-0 space-y-6">{work}</div>
        <div data-column="enquiry" className="min-w-0 space-y-6">{enquiry}</div>
      </div>
    </div>
  )
}
